<template>
	<ViewFeedItem class="view-feed-systemmessage">
		<template v-slot:header><!----></template>

		<template v-slot:body>
			<section v-html="html"></section>
		</template>
	</ViewFeedItem>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Feed
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewFeedSystemMessage extends ViewBase {
		/**
		 * @type string[]
		 */
		@Prop({
			default: '<p>Thank you for using ChalkySticks</p>',
		})
		public html!: string;
	}
</script>

<style lang="scss">
	.view-feed-systemmessage {
		// Not implemented
	}
</style>
